

import { TriStateCheckbox as PrimeReactTriStateCheckbox, TriStateCheckboxProps as PrimeReactTriStateCheckboxProps } from 'primereact/tristatecheckbox';
import './style.css';

interface ITriStateCheckbox extends PrimeReactTriStateCheckboxProps {
    label?: string;
    labelStyle?: React.CSSProperties;
    error?: string | null;
    wrapperStyle?: React.CSSProperties;
}

export const TriStateCheckbox: React.FC<ITriStateCheckbox> = ({
    label,
    name,
    labelStyle,
    error,
    ...rest
}) => {
    return (
        <div className='custom-input-checkbox' style={rest.wrapperStyle}>
            <span>
                <label
                    htmlFor={name}
                    style={{
                        marginRight: '8px',
                        display: label ? 'inherit' : 'none',
                        ...labelStyle,
                    }}
                >
                    {label}
                </label>
                <PrimeReactTriStateCheckbox
                    className={
                        rest.className +
                        (error ? '  p-invalid' : '') +
                        (rest.disabled ? '  p-disabled' : '')
                    }
                    {...rest}
                />
                {error && (
                    <small
                        id={`${name}-help`}
                        className='p-error block input-checkbox-error'
                    >
                        {error}
                    </small>
                )}
            </span>
        </div>
    );
};
